import * as styledElements from "./PrivacyStyles";

const PrivacyComponent = ({ privacyHtml }: { privacyHtml: string }) => {
  return (
    <styledElements.Container>
      <styledElements.Privacy
        dangerouslySetInnerHTML={{ __html: privacyHtml }}
      />
    </styledElements.Container>
  );
};

export default PrivacyComponent;
